import Vue from 'vue'
import { abilitiesPlugin } from '@casl/vue'
import { user } from '~/constants'
import userAbilities from './abilities'

let abilities = null

if (user && user.role) {
  abilities = userAbilities(user, user.role.name)

  Vue.use(abilitiesPlugin, abilities)
  Vue.prototype.$user = user
}

export { abilities }
